

<template>
  <!-- <div class="div1">
    <div class="div10"
         id="div10">
      <img src="../assets/images/new1.png"
           style="height:112vh">
    </div>
    <div class="div11"
         id="div11">
      <img src="../assets/images/new2.png"
           style="height:112vh">
    </div>
    <div class="div12"
         id="div12">
      <img src="../assets/images/new3.png"
           style="height:112vh">
    </div>

  </div> -->

  <el-carousel arrow="never"
               :interval="2000"
               :height="height">
    <el-carousel-item v-for="item in imgList"
                      :key="item">
      <img :src="item.src"
           style="width:100%">
      <img :src="item.src"
           style="width:100%">
    </el-carousel-item>
  </el-carousel>
  <div class="div2"
       style="margin-top:150px">
    <div>
      <img src="../assets/images/lod.png">
    </div>

  </div>

  <div class="div2"
       style="margin-top:50px">
    <div>
      <span class="content1">
        NZONE ，是面向Z世代人群打造的全新的终端品牌
      </span>
    </div>
  </div>

  <div class="div2"
       style="margin-top:140px">
    <div>
      <span class="content5">
        品牌动态
      </span>
    </div>
  </div>

  <div class="div2">
    <div class="div3"
         style="">
      <div style="text-align:left; max-width:300px; margin-right:60px">
        <span class="content3">品牌发布</span><br>
        <span class="content2"
              style="margin-top:10px">NZONE品牌正式发布</span>

        <p class="content4"
           style="margin-top:130px">2021年6月22日</p>
      </div>

      <video src="../assets/instruction.mp4"
             controls='controls'
             poster="../assets/images/video.png"
             style="max-width:910px;border-radius:0 10px 10px 0;"></video>

    </div>

  </div>

  <!-- <img src="../assets/images/instruction.jpg" style="width:100%; margin-top:10px" >


  <div>

      
  </div>

  <div>
      <div class="div1">
          <span class="content1">

NZONE ，是中国移动面向Z世代人群打造的全新的终端品牌


</span>

      </div>

      <div class="div1"> 

          <img src="../assets/images/new.png" style="margin-right:30px; width:600px">

      </div>
      
      <div style="display:flex; justify-content:center">

           <div class="div2" >
          <div style="margin-left:30px">
              <span class="content2">探索未来</span>

          </div>

          

          <div>
              <span class="content2">体验新奇</span>
          </div>

         

          <div style="margin-right:20px">
              <span class="content2">连接认同</span>
          </div>
      </div>
          
      </div>
     

      <div class="div1" style="margin-top:100px; margin-bottom:169px">
          <div style="max-width:1250px;margin:auto">
               <p class="content3">
              N是Next，代表着探索未来。NZONE鼓励年轻人用无所畏惧、一往无前的探索精神。

          </p>
          <p class="content3">
              N是New，代表着体验新奇。NZONE希望为热爱追逐新潮的年轻人，提供新颖奇特的体验和有趣的玩法。

          </p>

          <p class="content3">
              N是Net，代表着连接认同。不仅仅是人与人的物理连接与沟通，更是认同的连接。

          </p>

          <p class="content3">
              ZONE是真正属于Z世代的潮玩空间。在这里，每一个人都可以做自己，大胆的追求与众不同，找到属于自己的圈层。

          </p>

          <p class="content3">
              希望年轻人通过NZONE的智能终端创新产品去探索、去体验，去打破边界，一起“玩无界 潮无限”。

          </p>


          </div>
         

      </div>

      <div class="div1">
          <div class="div_img">
              
              <img src="../assets/images/6.jpg" style="width:350px">
              <img src="../assets/images/7.jpg" style="width:350px">
              <img src="../assets/images/8.jpg" style="width:350px">

          </div>

      </div>

      <div class="div1" >
          <video src="../assets/instruction.mp4" controls = 'controls' poster="../assets/images/video.png" style="max-width:1250px"></video>
      </div>

      

  </div> -->

</template>

<script lang="ts">
import { onBeforeMount, ref, defineComponent } from "vue";
interface imgListProp {
  name: string;
  src: string;
  title?: string;
}

const hadelInput = () => {
  const inputVla = ref("");
  return inputVla;
};

export default defineComponent({
  data() {
    return {
      height: "",
      color: "purple",
    };
  },

  methods: {
    getHeight() {
      this.height = this.height = (window.innerWidth * 2842) / 4997 - 50 + "px";
    },
  },
  mounted() {
    let div10 = document.getElementById("div10");
    setTimeout(() => {
      if (div10 != null) div10.style.transform = "translate(0, 0)";
    }, 100);

    let div11 = document.getElementById("div11");
    setTimeout(() => {
      if (div11 != null) div11.style.transform = "translate(0, 0)";
    }, 100);

    let div12 = document.getElementById("div12");
    setTimeout(() => {
      if (div12 != null) div12.style.transform = "translate(0, 0)";
    }, 100);

    this.getHeight();
  },
  setup() {
    let imgList = ref<imgListProp[] | null>(null);
    const result = hadelInput();
    onBeforeMount(() => {
      imgList.value = [
        {
          name: "v1",
          src: require("../assets/images/carousel4.jpg"),
          title: "v1",
        },
        {
          name: "v1",
          src: require("../assets/images/carousel5.jpg"),
          title: "v1",
        },
      ];
    });
    return { result, imgList };
  },
});
</script>

<style scoped>
.image {
  margin-top: 100px;
  width: 100%;
}

.title2 {
  font-size: 48px;
  font-style: SourceHanSansSC-bold;
  color: black;
  text-decoration: none;
  position: absolute;
  top: 45%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  color: white;
  font-weight: bold;
}

.content1 {
  font-size: 24px;
  font-style: SourceHanSansSC;
  color: #646464 100%;
}

.content2 {
  font-size: 28px;
  font-style: SourceHanSansSC-regular;
  color: #010101;
  font-weight: bold;
}

.content3 {
  font-size: 18px;
  font-style: SourceHanSansSC-regular;
  color: #010101;
}

.content4 {
  font-size: 14px;
  font-style: SourceHanSansSC-regular;
  color: #575c66;
}
.div1 {
  display: flex;
  justify-content: center;
  margin-top: 80px;
  overflow: hidden;
  height: 112vh;
  /* height: 950px; */
  /* height: 110vh; */
  /* position: absolute; */
}

.div10 {
  transform: translate(130vh, 0);
  transition: transform 1s;
}

.div11 {
  transform: translate(65vh, 0);
  transition: transform 1s;
}

.div12 {
  transform: translate(-65vh, 0);
  transition: transform 1s;
}

.div2 {
  display: flex;
  justify-content: center;
}

.div3 {
  display: flex;
  justify-content: center;
  margin-top: 70px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 100px;

  max-width: 1300px;
  padding-left: 30px;
  border-radius: 10px;
}

.content5 {
  font-style: SourceHanSansSC-bold;
  font-size: 40px;
  color: #101010;
  font-weight: bold;
}

:deep() .el-carousel {
  z-index: 0;

  height: 100%;
}
:deep().is-active .el-carousel__button {
  width: 15px;
  height: 15px;
  background-color: black;
  border-radius: 15px;
  margin: 3.5px;
  margin-bottom: 0;
}
:deep().el-carousel__indicator--horizontal .el-carousel__button {
  width: 15px;
  height: 15px;
  background-color: black;
  border-radius: 15px;
  margin: 3.5px;
  margin-bottom: 0;
}
</style>
